import { Activity, BarChart3, HeartPulse, Lightbulb, Scale } from 'lucide-react';
import type { ComponentType } from 'react';

export type AppRoute = 'today' | 'training' | 'body' | 'health' | 'insights';

export type NavItem = {
  route: AppRoute;
  label: string;
  icon: ComponentType<{ size?: number; strokeWidth?: number }>;
};

export const navItems: NavItem[] = [
  { route: 'today', label: 'Today', icon: BarChart3 },
  { route: 'training', label: 'Training', icon: Activity },
  { route: 'body', label: 'Body', icon: Scale },
  { route: 'health', label: 'Health', icon: HeartPulse },
  { route: 'insights', label: 'Insights', icon: Lightbulb },
];

export function getRouteFromPath(pathname: string): AppRoute {
  const segment = pathname.replace(/^\/+/, '').split('/')[0];
  if (segment === 'training' || segment === 'body' || segment === 'health' || segment === 'insights') {
    return segment;
  }
  return 'today';
}

export function routeToPath(route: AppRoute) {
  return route === 'today' ? '/' : `/${route}`;
}
